import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from 'vuex-persistedstate';
import createSocketIoPlugin from "vuex-socketio";
import socketio from "socket.io-client";
import state from "./state.js";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";
import socketModule from "./modules/socketModule.js";
import channelModule from "./modules/channelModule.js";
import bagnoArrivalModule from "./modules/bagnoArrivalModule.js";
import bagnoProcessModule from "./modules/bagnoProcessModule.js";
import alfaberriesProcess from "./modules/alfaberriesProcess";

const socket = socketio("https://scale.packapp.cl", { autoConnect: false });
const socketPlugin = createSocketIoPlugin(socket);

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    socketModule,
    channelModule,
    bagnoArrivalModule,
    bagnoProcessModule,
    alfaberriesProcess
  },
  state,
  getters,
  mutations,
  actions,
  plugins: [socketPlugin]
});
